// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1iZuu","colMin":"styles_colMin__siRON","colCheckbox":"styles_colCheckbox__2dsHN"};